import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import * as Sentry from '@sentry/angular';

// Sentry.init({
//     dsn: 'https://5517835db366973702955ce8b20dc149@o4510018530115584.ingest.de.sentry.io/4510018532737104',
//     // Setting this option to true will send default PII data to Sentry.
//     // For example, automatic IP address collection on events
//     sendDefaultPii: true
// });

Sentry.init({
    dsn: 'https://5517835db366973702955ce8b20dc149@o4510018530115584.ingest.de.sentry.io/4510018532737104', //'https://examplePublicKey@o0.ingest.sentry.io/0',
    // tunnel: '/tunnel',
    integrations: [
        Sentry.browserTracingIntegration(),
        // // optional extras:
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false
        })

        // Sentry.feedbackIntegration({
        //     triggerLabel: 'Αναφορά Σφάλματος', // replaces "Report a Bug"
        //     colorScheme: 'system',
        //     isNameRequired: true,
        //     isEmailRequired: true
        // })
    ],
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/angular/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    // tracesSampleRate: 1.0,
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/]
    // profilesSampleRate: 1.0, // if using profiling
    // replaysSessionSampleRate: 0.1, replaysOnErrorSampleRate: 1.0, // if using Replay
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
